import { Link } from "react-router-dom";
import SEO from "@/components/SEO";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="max-w-2xl mx-auto px-6 md:px-10 py-24 text-center fade-in" data-testid="page-payment-cancel">
      <SEO title="Payment cancelled" path="/payment/cancel" />
      <XCircle size={48} className="mx-auto text-[#86868B]" />
      <h1 className="text-h2 mt-6">Payment cancelled</h1>
      <p className="text-[#86868B] mt-3">Your cart is safe. Whenever you are ready, we will be here.</p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Link to="/checkout" className="btn-primary">Return to checkout</Link>
        <Link to="/shop" className="btn-secondary">Keep shopping</Link>
      </div>
    </div>
  );
}
